import React, { useEffect, useState } from 'react'
import actions from '../reducers/actions'
import { connect } from 'react-redux'
import {
  Modal,
  Typography,
  Paper,
  FormControlLabel,
  Switch,
  Grid,
  CircularProgress,
  Button,
  Chip,
  Avatar,
  Table, TableHead, TableRow, TableCell, TableBody
} from '@material-ui/core'
import { Add, AccountCircle, MoreVert } from '@material-ui/icons'
import UserModal from '../components/UserModal'
import Navigation from '../components/Navigation'
import { getTitle } from '../utils'
import { MANAGE_USERS } from '../constants/permissions'

function UsersPage(props) {
  document.title = getTitle()
  const [state, setState] = useState({ fetching: true, showModal: false, modalUser: null, showInactive: false })

  const { user, upsertUser, logout, endImpersonation, setOverrideUrl } = props

  useEffect(() => {
    const { getUsers, getPermissions, getUserInfo, getVendors, getEmployees } = props

    setState({ ...state, fetching: true })

    const promises = [
      getUsers(user),
      getVendors(user),
      getEmployees(user),
      getUserInfo(user),
      getPermissions(user)
    ]

    Promise.all(promises)
      .catch(console.log)
      .finally(() => setState({ ...state, fetching: false }))
  }, [user.overrideUrl])


  function setShowModal(modalUser) {
    return () => {
      setState({ ...state, showModal: true, modalUser })
    }
  }

  function hideModal() {
    setState({ ...state, showModal: false, modalUser: null })
  }

  function renderTable() {
    const { showInactive } = state
    const { user: { users } } = props
    const filteredUsers = showInactive ? users : users.filter(({ Active }) => Active)
    return (
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Username</TableCell>
            <TableCell>Vendor</TableCell>
            <TableCell>Permissions</TableCell>
            <TableCell>Time Sheet Rows</TableCell>
            <TableCell>Active</TableCell>
            <TableCell />
            <TableCell />
          </TableRow>
        </TableHead>

        <TableBody>
          {filteredUsers.map(renderTableRows)}
        </TableBody>
      </Table>
    )
  }

  function renderTableRows(user, key) {
    const { VendorIdd, VendorName, Username, Permissions, TimeSheetRowCount, Active } = user
    return (
      <TableRow style={{ cursor: 'pointer' }} hover key={key} onClick={setShowModal(user)}>
        <TableCell style={{ width: 100 }}>
          <Chip
            label={Username}
            color="secondary"
          />
        </TableCell>

        <TableCell style={{ width: 250 }}>
          <Chip
            avatar={<Avatar><AccountCircle /></Avatar>}
            label={VendorName}
            color="primary"
          />
        </TableCell>

        <TableCell>
          <Grid container direction="row">
            {Permissions.map((permission, key) => <Chip key={key} label={permission} />)}
          </Grid>
        </TableCell>

        <TableCell>
          {TimeSheetRowCount}
        </TableCell>

        <TableCell>
          <Chip
            label={Active ? 'Yes' : 'No'}
            color="secondary"
          />
        </TableCell>

        {props.user.username.toLowerCase() === 'admin' && (
          <TableCell>
            <Chip
              label='Impersonate'
              color="secondary"
              onClick={(e) => {
                e.stopPropagation()
                props.startImpersonation(props.user, user)
              }}
            />
          </TableCell>
        )}

        <TableCell style={{ width: 25 }}>
          <MoreVert />
        </TableCell>
      </TableRow>
    )
  }

  const { vendors, employees, allPermissions } = user
  const { fetching, showModal, modalUser, showInactive } = state
  const canManageUsers = user.permissions.includes(MANAGE_USERS)

  return (
    <Grid>
      <Navigation logout={() => logout(user)} user={user} endImpersonation={endImpersonation} setOverrideUrl={setOverrideUrl} />

      <Paper style={{ margin: 'auto', marginTop: 75, width: 1000 }}>
        {fetching
          ? <CircularProgress style={{ marginTop: 85, width: 50, margin: 'auto' }} />
          : (
            <div>
              <div style={{ display: 'flex', flexDirection: 'row' }}>
                <Typography
                  style={{ flex: 1, padding: 10 }}
                  variant="h4"
                  color="primary"
                >
                  {canManageUsers ? 'Users' : 'Profile'}
                </Typography>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                  {canManageUsers && (
                    <FormControlLabel
                      style={{ marginRight: 20, whiteSpace: 'nowrap' }}
                      label="Show Inactive"
                      labelPlacement="start"
                      control={(
                        <Switch
                          checked={showInactive}
                          onChange={({ target: { checked } }) => setState({ ...state, showInactive: checked })}
                          color="primary"
                          inputProps={{ 'aria-label': 'primary checkbox' }}
                        />
                      )}
                    />
                  )}

                  {canManageUsers && (
                    <Grid container alignItems="flex-start" justify="flex-end" direction="row" style={{ padding: 10 }}>
                      <Button variant="contained" color="primary" onClick={setShowModal(null)}>
                        <Add />
                        Add User
                      </Button>
                    </Grid>
                  )}
                </div>
              </div>

              {renderTable()}

            </div>
          )}
      </Paper>

      <Modal
        open={showModal}
        onClose={hideModal}
        aria-labelledby="User Modal"
        aria-describedby="Add or edit users"
      >
        <UserModal
          {...{ modalUser, hideModal, vendors, employees, allPermissions, upsertUser, user }}
        />
      </Modal>
    </Grid>
  )
}

const mapStateToProps = (state, ownProps) => {
  return { ...state, ...ownProps }
}

export default connect(mapStateToProps, actions)(UsersPage)